import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { isAxiosError } from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import { TracewayProvider } from '@tracewayapp/react';
import * as Sentry from "@sentry/react";
import packageJson from '../package.json';
//
import App from './App';

const TRACEWAY_CONNECTION_STRING = import.meta.env.PROD
  ? "1ef4cd4403d440888853651a71abf100@https://cloud.tracewayapp.com/api/report"
  : "frontend@http://localhost:8082/api/report";

Sentry.init({
  dsn: "https://9f3cc5be9eeed93dc2dc093fc60fbaed@o4506243148087296.ingest.us.sentry.io/4510000354033664",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  beforeSend(event, hint) {
    const error = hint.originalException;
    if (isAxiosError(error)) {
      // we'll only keep 500 errors
      return error.response?.status === 500 ? event : null;
    }
    return event;
  }
});


// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <TracewayProvider connectionString={TRACEWAY_CONNECTION_STRING} options={{ version: packageJson.version }}>
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </TracewayProvider>
);
